import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  advertising: [],
  bidding: [],
  unrated: []
}

const store = {
  state,
  actions,
  getters,
  mutations
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/bid-sessions/index.js